async function waitForProperty(target, property, intervalMs = 100, timeoutMs = 5000) {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();

    const check = () => {
      if (property in target) {
        resolve(target[property]);
      } else if (Date.now() - startTime >= timeoutMs) {
        reject(new Error("Adcell not found"));
      } else {
        setTimeout(check, intervalMs);
      }
    };

    check();
  });
}

waitForProperty(window, 'Adcell').then(() => {
  Adcell.Tracking.track();
});